import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  BackgroundContent,
} from 'components';

const Certificates = () => (
  <Section color={'white'}>
    <SectionHeader
      size={'big'}
      lineColor={'red'}
      headingType={2}
      description={
        'Boldare’s AI developers continue to improve their skills and broaden their knowledge by attending conferences, taking part in competitions and hackathons, as well as attending numerous courses on machine learning, deep learning and data science:'
      }
    >
      Certificates
      <br />
      and courses
    </SectionHeader>
    <Row className={'no-gap anim-fade-in-bottom machine-learning__cert-list'}>
      <Col sm={6} md={3} className={'machine-learning__cert-item'}>
        <BackgroundContent content={'1'} color={'red'} />
        <Heading type={3} size={'medium'}>
          Practical Machine Learning by DataWorkshop
        </Heading>
      </Col>
      <Col sm={6} md={3} className={'machine-learning__cert-item'}>
        <BackgroundContent content={'2'} color={'red'} />
        <Heading type={3} size={'medium'}>
          Machine Learning by Stanford University
        </Heading>
      </Col>
      <Col sm={6} md={3} className={'machine-learning__cert-item'}>
        <BackgroundContent content={'3'} color={'red'} />
        <Heading type={3} size={'medium'}>
          Google Machine Learning Kickstarter
        </Heading>
      </Col>
      <Col sm={6} md={3} className={'machine-learning__cert-item'}>
        <BackgroundContent content={'4'} color={'red'} />
        <Heading type={3} size={'medium'}>
          Cloudera Data Analyst Training
        </Heading>
      </Col>
    </Row>
  </Section>
);

export default Certificates;
